var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lf-counter-container" },
    _vm._l(_vm.items, function ({ detail, totalAmount }, index) {
      return _c("div", { key: index, staticClass: "lf-counter-wrapper" }, [
        _c("div", { staticClass: "lf-counter" }, [
          _c("span", { class: _setup.getDetailClass(detail) }, [
            _vm._v(_vm._s(detail)),
          ]),
          _c("span", { staticClass: "number" }, [_vm._v(_vm._s(totalAmount))]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }